export const DEFAULT_TIMEZONE = 'utc';
export const DEFAULT_TEMPLATE = 'LLL';
export const DEFAULT_EMPTY = '—';
export const DEFAULT_LOCALE = 'il';
export const longDateFormats: any = {
  au: {
    LT: 'h:mm A',
    LTS: 'h:mm:ss A',
    L: 'MM/d/yyyy',
    LL: 'MMM d yyyy',
    LLL: 'MMM d yyyy, h:mm A',
    LLLL: 'MMM d yyyy, h:mm:ss A',
    MONTH: 'MMM yyyy',
  },
  gb: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'dd/MM/yyyy',
    LL: 'd MMM yyyy',
    LLL: 'd MMM yyyy, HH:mm',
    LLLL: 'd MMM yyyy, HH:mm:ss',
    MONTH: 'MMM yyyy',
  },
  il: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'dd/MM/yyyy',
    LL: 'd MMM yyyy',
    LLL: 'd MMM yyyy, HH:mm',
    LLLL: 'd MMM yyyy, HH:mm:ss',
    MONTH: 'MMM yyyy',
  },
  us: {
    LT: 'h:mm A',
    LTS: 'h:mm:ss A',
    L: 'MM/d/yyyy',
    LL: 'MMM d yyyy',
    LLL: 'MMM d yyyy, h:mm A',
    LLLL: 'MMM d yyyy, h:mm:ss A',
    MONTH: 'MMM yyyy',
  },
};
